import { ColorsTypes } from '~/ui/theme/colors';
import { CommentType, CommentTypeName } from '~/typings/entities/Ticket';

export type CommentTypeMeta = {
  // Visual metadata only. The label text always comes from the backend (mt-ticket) via the
  // comment type's `description`, so adding a new message type does not require a front change.
  // Either a theme palette key or an explicit { bg, text } color pair (used when the theme
  // has no matching palette, e.g. yellow for public messages).
  palette?: ColorsTypes;
  colors?: { bg: string; text: string };
};

// Visual metadata for each comment type, shared between the resolution review and the
// comment listing so the badges stay consistent across screens.
const COMMENT_TYPE_META: Record<CommentTypeName, CommentTypeMeta> = {
  // Cores invertidas: fundo escuro + texto claro para acompanhar o tema escuro.
  PUBLIC_RA: { colors: { bg: '#854D0E', text: '#FEF9C3' } },
  // Cinza (neutral) com fundo um pouco mais claro — ver resolvePalette em CommentTypeBadge.styles.
  PRIVATE_RA: { palette: 'gray' },
  WHATSAPP: { palette: 'success' },
  BACKOFFICE: { colors: { bg: '#A8005B', text: '#FCE7F1' } },
};

const DEFAULT_META: CommentTypeMeta = COMMENT_TYPE_META.BACKOFFICE;

export function getCommentTypeMeta(type?: CommentType | CommentTypeName | null): CommentTypeMeta {
  if (!type) return DEFAULT_META;
  const name = (typeof type === 'string' ? type : type.name)?.toUpperCase() as CommentTypeName;
  return COMMENT_TYPE_META[name] || DEFAULT_META;
}
